import { inject, Injectable } from '@angular/core';
import { ApiService } from '../../../../core/services/ApiService';
import { Observable, tap } from 'rxjs';
import { IResponse } from '../../../../core/interfaces/IResponse';
import { IIdAndName } from '../../../../core/interfaces/IIdAndName';
import { DatevStore } from '../stores/DatevStore';

@Injectable({
  providedIn: 'root'
})
export class DatevService {

  private readonly _basePath = '/datev';
  private readonly _apiService = inject(ApiService);
  private readonly _datevStore = inject(DatevStore);

  public getDatevAccounts(): Observable<IResponse<IIdAndName<number>[]>> {
    return this._apiService.get(`${this._basePath}/items`)
      .pipe(
        tap(res => this._datevStore.datevAccounts.set(res.data))
      );
  }
}
